import type { Placement } from '../types';

export const placementConfig: Record<Placement, string[]> = {
    'recently-viewed': ['en-us'],
};
